import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/cn'

interface SpinnerProps extends React.HTMLAttributes<SVGElement> {
  label?: string
  size?: number
}

/**
 * Accessible loading indicator. Pair with a `label` for screen readers
 * unless the surrounding region already announces loading state.
 */
export function Spinner({ className, label = 'Loading', size = 16, ...props }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      size={size}
      className={cn('animate-spin text-muted-fg', className)}
      {...props}
    />
  )
}
